/**
 * Pure H OS · Phase D · P0 Interaction Depth · LinkedRefChip.
 *
 * Renders a foreign-key `id` (like "d-001") as either a clickable Link
 * (when the id is resolvable via `resolveLinkedRef`) or an inert <code>
 * chip (when it's not). Same visual grammar as before — this component
 * just adds interaction.
 */
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { resolveLinkedRef, LinkedKind } from "../lib/linkedRef";

export function LinkedRefChip({
  id, kind, children, testId,
}: {
  id: string | null | undefined;
  kind?: LinkedKind | string | null;
  children?: ReactNode;
  testId?: string;
}) {
  if (!id) return null;
  const ref = resolveLinkedRef(id, kind);
  const label = children ?? <code>{id}</code>;
  if (!ref) {
    return <span data-testid={testId} className="opacity-90">{label}</span>;
  }
  return (
    <Link
      to={ref.path}
      data-testid={testId ?? `linked-${id}`}
      className="underline underline-offset-2 hover:opacity-80"
      style={{ color: "var(--ph-accent)" }}
      title={ref.label}
    >
      {label}
    </Link>
  );
}
